import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Brand gradient clip-text (#4E9CFF → #FF4DB8). Wrap inline text inside a heading. */
const GradientText = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <span
    className={cn(
      "bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] bg-clip-text text-transparent",
      className
    )}
  >
    {children}
  </span>
);

export default GradientText;
